import { FC } from 'react';
import { useIntercom } from 'react-use-intercom';

import { logEvent } from 'features/Analytics/analytics';
import * as OfferDetailsLayout from 'layouts/OfferDetailsLayout';

import locales from './locales';

interface ClaimIntercomButtonProps {
  offerName: string;
  intercomMessage: string;
}

const ClaimIntercomButton: FC<ClaimIntercomButtonProps> = ({
  intercomMessage,
  offerName,
}) => {
  const intercom = useIntercom();

  return (
    <OfferDetailsLayout.HeaderCta
      icon="link"
      onClick={() => {
        logEvent({
          name: 'InsuranceOfferDetails Intercom Clicked',
          properties: {
            action: 'Make a claim',
            offer: offerName,
          },
          usePrefix: false,
        });

        intercom.hide();
        intercom.showNewMessages(intercomMessage);
      }}
    >
      {locales.title}
    </OfferDetailsLayout.HeaderCta>
  );
};

export default ClaimIntercomButton;
